var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('br'),_c('h2',[_vm._v("Register here!")]),_c('br'),_c('registration-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }